/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedinteraccountingemail23Inputs */

const en__field_inheritedinteraccountingemail23 = /** @type {(inputs: _Field_Inheritedinteraccountingemail23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`internal accounting e-mail 2 (inherited)`)
};

const de__field_inheritedinteraccountingemail23 = /** @type {(inputs: _Field_Inheritedinteraccountingemail23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Accounting E-Mail 2 (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "internal accounting e-mail 2 (inherited)" |
*
* @param {_Field_Inheritedinteraccountingemail23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedinteraccountingemail23 = /** @type {((inputs?: _Field_Inheritedinteraccountingemail23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedinteraccountingemail23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedinteraccountingemail23(inputs)
	return de__field_inheritedinteraccountingemail23(inputs)
});
export { _field_inheritedinteraccountingemail23 as "_field_inheritedInterAccountingEmail2" }